// Admin user management (issue #379). Shapes mirror the backend's
// GET /api/v1/admin/users response and the models.User Go struct.

/** Roles an account can hold. Mirrors internal/api/rbac. */
export type UserRole = 'admin' | 'operator';

/** Account state. A disabled user is rejected at the API's auth boundary. */
export type UserStatus = 'active' | 'disabled';

/** All assignable roles, in the order the admin table offers them. */
export const USER_ROLES: readonly UserRole[] = ['admin', 'operator'] as const;

/**
 * A durable user account, created just-in-time on first login and keyed on the
 * Dex `sub` (issue #376).
 */
export interface AdminUser {
  subject: string;
  email: string;
  display_name: string;
  status: UserStatus;
  created_at: string;
  /** Null until the account's first authenticated request. */
  last_login_at: string | null;
  /** Absent rather than empty when the user holds no roles. */
  roles?: UserRole[];
}

/** One page of accounts. */
export interface AdminUserListResponse {
  users: AdminUser[];
  total: number;
  limit: number;
  offset: number;
}

/** Operator-facing name: their profile name, else the email, else the subject. */
export const adminUserName = (u: AdminUser): string =>
  u.display_name?.trim() || u.email?.trim() || u.subject;
